import { CrossIcon, DropdownIcon, ProposalAlertIcon } from '@/components/assets/icons/svgs'
import ContentContainer from '@/components/containers/contentContainer'
import CustomButton from '@/shared/button/customButton'
import Inputfield from '@/shared/inputfield'
import Popup from '@/shared/popups/popupDetails'
import Select from '@/shared/select/select'
import TextArea from '@/shared/textArea/textArea'
import { api } from '@/utils/api'
import { getBackendCallErrorMessage } from '@/utils/backendErrorMessage'
import type { MyVoucher, ProviderVoucherPreview } from '@/types/jobPaymentTypes'
import React, { useEffect, useState, FormEvent, useRef } from 'react'
import { components as selectComponents } from 'react-select';
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import type { GoogleLocation } from '@/types/googleLocationTypes';
import { toast } from "@/utils/appToast";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux'
import DragDropImagePicker from '@/shared/dragDropImage'
import Resizer from "react-image-file-resizer";
import { FileTypes } from '@/shared/utils/enum'
import LocationPickerPopup, { LocationData } from '@/components/shared/location/LocationPickerPopup';
import { LocationPinIcon } from '@/components/assets/icons/svgs';
import { User, WorkerProfile } from '@/types/userTypes'
import { useTranslation } from 'react-i18next';
import { trackUserAction } from '@/utils/analytics';
import { trackMetaSubmitApplication } from '@/utils/metaPixel';
import AssignedVoucherPicker from '@/components/vouchers/AssignedVoucherPicker'
import { filterUsableVouchersForAudience } from '@/utils/vouchers'

// 
// Mobile-only date picker styles
const mobileDatePickerStyles = `
  @media (max-width: 768px) {
    .react-datepicker {
      width: 100% !important;
      max-width: 320px !important;
    }
    
    .react-datepicker__month-container {
      width: 100% !important;
      float: none !important;
    }
    
    .react-datepicker__time-container {
      width: 100% !important;
      float: none !important;
      border-left: none !important;
      border-top: 1px solid #aeaeae !important;
    }
    
    .react-datepicker__time {
      border-radius: 0 0 0.3rem 0.3rem !important;
    }
    
    .react-datepicker__time-list {
      height: 120px !important;
      max-height: 120px !important;
    }
    
    .react-datepicker__time-list-item {
      height: 30px !important;
      line-height: 30px !important;
      padding: 0 8px !important;
    }
    
    .react-datepicker__header--time {
      border-radius: 0.3rem 0.3rem 0 0 !important;
    }
    
    .react-datepicker__day {
      width: 32px !important;
      height: 32px !important;
      line-height: 32px !important;
      margin: 2px !important;
      font-size: 14px !important;
    }
    
    .react-datepicker__month {
      margin: 0.4rem !important;
    }
    
    .react-datepicker__current-month {
      font-size: 16px !important;
      padding: 8px 0 !important;
    }
    
    .react-datepicker__navigation {
      top: 8px !important;
    }
    
    .react-datepicker__navigation--previous {
      left: 8px !important;
    }
    
    .react-datepicker__navigation--next {
      right: 8px !important;
    }
  }
  
  @media (max-width: 480px) {
    .react-datepicker {
      max-width: 280px !important;
    }
    
    .react-datepicker__day {
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      margin: 1px !important;
      font-size: 12px !important;
    }
    
    .react-datepicker__time-list-item {
      height: 25px !important;
      line-height: 25px !important;
      font-size: 12px !important;
    }
  }
`;

interface SendProposalProps {
  workerid: string;
  workerProfileId: string;
  jobUserID: string,
  jobtype: string
  jobId: string
  onSuccess?: () => void;
}
const paymentOptions = [
  {
    label: 'hourly',
    value: 'hourly'
  },
  {
    label: 'fixed',
    value: 'fixed'
  },

];

const CustomDropdownIndicator = (props: any) => (
  <selectComponents.DropdownIndicator {...props}>
    <DropdownIcon className="w-4 h-4" />
  </selectComponents.DropdownIndicator>
);
const googlePlacesApiKey = import.meta.env.VITE_GOOGLE_PLACES_API_KEY;


const SendProposal = ({ workerid, workerProfileId,jobId,jobUserID,jobtype,onSuccess }: SendProposalProps) => {
  const { t, i18n } = useTranslation();
  const { user } = useSelector((state: { user }) => state.user || {});
  const providerCommission = import.meta.env.VITE_PROVIDER_COMMISSION;
  const [googleLocation, setGoogleLocation] = useState<GoogleLocation>();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [isUploadingImages, setIsUploadingImages] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState('');
  const [selectedService, setSelectedService] = useState<string>('');
  const [categoryServices, setCategoryServices] = useState([]);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [imagePreviews, setImagePreviews] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [pendingFormData, setPendingFormData] = useState<any>(null);
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<LocationData | null>(null);
  const [googlePlace, setGooglePlace] = useState<any>(null);
  const [googlePlaceAddress, setGooglePlaceAddress] = useState<string>('');
  const [urgency, setUrgency] = useState<'low' | 'medium' | 'high'>('low');
  const [workerDetails, setWorkerDetails] = useState<WorkerProfile>();
  const [clientDetails,setClientDetails] = useState<User>()
 const [isLoading, setIsLoading] = useState(true);
 const [Budget ,setBudget] = useState(0)
 const [existingJobId,setExistingJobId]=useState('')
 const [voucherCode, setVoucherCode] = useState('')
 const [appliedVoucherCode, setAppliedVoucherCode] = useState<string | null>(null)
 const [voucherPreview, setVoucherPreview] = useState<ProviderVoucherPreview | null>(null)
 const [isApplyingVoucher, setIsApplyingVoucher] = useState(false)
 const [usableAssignedVouchers, setUsableAssignedVouchers] = useState<MyVoucher[]>([])
 const hasFetchedRef = useRef(false);



 const isToday = (date: Date | null) => {
  if (!date) return false;
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};



const getMinTime = (date: Date | null) => {
  if (!date) return undefined;

  const now = new Date();
  const selected = new Date(date);

  // If today → block past time
  if (
    selected.getDate() === now.getDate() &&
    selected.getMonth() === now.getMonth() &&
    selected.getFullYear() === now.getFullYear()
  ) {
    return new Date(
      selected.getFullYear(),
      selected.getMonth(),
      selected.getDate(),
      now.getHours(),
      now.getMinutes()
    );
  }

  // Future date → allow full day
  return new Date(
    selected.getFullYear(),
    selected.getMonth(),
    selected.getDate(),
    0,
    0
  );
};

const getMaxTime = (date: Date | null) => {
  if (!date) return undefined;

  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59
  );
};





const populateClientDetails = async () => {
  console.log("calling times 1")
  if (!jobId) return;

  try {
    setIsLoading(true);

  const res = await api.getProposalDetails({ id: jobId, userId: user?._id });

    if (!res?.success) {
      toast.error(res?.message || "Unable to load data");
      onSuccess()
      return;
    }
    if (!res?.data) {
      console.warn("No task found for jobId:", jobId);
      return;
    }

    const task = res?.data;
    console.log("Loaded job for proposal:", task);
   setExistingJobId(task?._id)
    // 🔹 Client
    setClientDetails(task.user);

    // 🔹 Category & Service
    setSelectedCategoryId(task.category?._id || '');
    setSelectedService(task.service?._id || '');

    // 🔹 Description (TEXTAREA)
    const descriptionInput = document.querySelector(
      'textarea[name="description"]'
    ) as HTMLTextAreaElement | null;
    if (descriptionInput) {
      descriptionInput.value = task.description || '';
    }

    // 🔹 Payment
    setSelectedPayment(task.paymentType || '');

    if (task.paymentType === 'hourly') {
      const hr = document.querySelector('input[name="hourlyRate"]') as HTMLInputElement | null;
      const th = document.querySelector('input[name="totalHours"]') as HTMLInputElement | null;

      if (hr) hr.value = task.hourlyRate?.toString() || '';
      if (th) th.value = task.totalHours?.toString() || '';

      setBudget((task.hourlyRate || 0) * (task.totalHours || 0));
    } else {
      const budgetInput = document.querySelector('input[name="budget"]') as HTMLInputElement | null;
       setBudget(task.budget ?? 0);
    }
    // 🔹 Urgency
    setUrgency(task.urgency || 'low');

    // 🔹 Location
    if (task.location) {
      setSelectedLocation({
        lat: task.location.coordinates[1],
        lng: task.location.coordinates[0],
        address: task.location.value,
      });

      setGooglePlace({
        label: task.location.value,
        value: { description: task.location.value },
      });
    }

    // 🔹 Schedule
    if (task.schedule?.startDateTime) {
      setStartDate(new Date(task.schedule.startDateTime));
    }

    // 🔹 Images (optional)
    if (task.imageUrls?.length) {
      setImagePreviews(task.imageUrls);
    }

  } catch (err) {
    console.error("Failed to populate proposal details:", err);
  } finally {
    setIsLoading(false);
  }
};

 useEffect(() => {
  let cancelled = false;
  (async () => {
    try {
      const res = await api.getMyVouchers();
      if (cancelled || !res?.success) return;
      setUsableAssignedVouchers(
        filterUsableVouchersForAudience(res.data || [], 'provider')
      );
    } catch {
      if (!cancelled) setUsableAssignedVouchers([]);
    }
  })();
  return () => {
    cancelled = true;
  };
 }, []);

 useEffect(() => {
  const getClientDetails = async () => {
    if (!jobUserID) return;
    try {
      const res = await api.getUserById(jobUserID);
       console.log("got successful response",res)
      if (res) {
       
        setClientDetails(res);
      } else {
        console.warn("Client fetch failed or returned empty data");
      }
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  if (hasFetchedRef.current) return;
  hasFetchedRef.current = true;

  if (jobId){
      populateClientDetails()
  }
  else{
    getClientDetails()
  }
 // getClientDetails();
  
}, [jobUserID]);

  const resolveProposalBudget = (): number | null => {
    if (selectedPayment === 'fixed') {
      const budgetInput = document.querySelector(
        'input[name="budget"]'
      ) as HTMLInputElement | null;
      const value = Number(budgetInput?.value || Budget || 0);
      return value > 0 ? value : null;
    }
    if (selectedPayment === 'hourly') {
      const hr = document.querySelector(
        'input[name="hourlyRate"]'
      ) as HTMLInputElement | null;
      const th = document.querySelector(
        'input[name="totalHours"]'
      ) as HTMLInputElement | null;
      const value = Number(hr?.value || 0) * Number(th?.value || 0);
      return value > 0 ? value : null;
    }
    return Budget > 0 ? Budget : null;
  };

  const clearAppliedVoucher = () => {
    setAppliedVoucherCode(null);
    setVoucherPreview(null);
  };

  const handleApplyProviderVoucher = async (codeOverride?: string) => {
    const code = (typeof codeOverride === 'string' ? codeOverride : voucherCode).trim().toUpperCase();
    if (!code) {
      toast.error(t('voucher_invalid'));
      return;
    }
    const budget = resolveProposalBudget();
    if (!budget) {
      toast.error(t('provider_voucher_need_budget'));
      return;
    }

    setIsApplyingVoucher(true);
    try {
      const res = await api.previewProviderVoucher({
        voucherCode: code,
        budget,
        jobId: existingJobId || jobId || undefined,
      });
      if (res?.success && res.data?.voucherCode) {
        setVoucherPreview(res.data);
        setAppliedVoucherCode(res.data.voucherCode);
        setVoucherCode(res.data.voucherCode);
        setBudget(budget);
        toast.success(
          t('platform_fee_discount_applied', {
            amount: Number(res.data.providerDiscountApplied || 0).toFixed(2),
          })
        );
      } else {
        clearAppliedVoucher();
        toast.error(res?.message || t('voucher_invalid'));
      }
    } catch {
      clearAppliedVoucher();
      toast.error(t('voucher_invalid'));
    } finally {
      setIsApplyingVoucher(false);
    }
  };

  const handleClearProviderVoucher = () => {
    setVoucherCode('');
    clearAppliedVoucher();
  };

  const handleSendProposal = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const codeFromForm = ((formData.get('voucherCode') as string) || voucherCode)
      .trim()
      .toUpperCase();

    if (codeFromForm && codeFromForm !== appliedVoucherCode) {
      toast.error(t('voucher_apply_required'));
      return;
    }

    const resolvedBudget =
      selectedPayment === 'fixed'
        ? Number(formData.get('budget') || 0)
        : Number(formData.get('totalHours') || 0) * Number(formData.get('hourlyRate') || 0);

    if (
      appliedVoucherCode &&
      voucherPreview &&
      resolvedBudget > 0 &&
      Math.abs(Number(voucherPreview.budget) - resolvedBudget) > 0.009
    ) {
      toast.error(t('provider_voucher_reapply_budget'));
      clearAppliedVoucher();
      return;
    }

    setPendingFormData({
      title: formData.get('title') as string,
      hourlyRate: formData.get('hourlyRate') as string,
      totalHours: formData.get('totalHours') as string,
      budget: formData.get('budget') as string,
      description: formData.get('description') as string,
      urgency,
      voucherCode: appliedVoucherCode || '',
    });
    const bud = formData.get('budget') as string;
    if(bud){
      console.log(" fixed budget",bud)
      setBudget(Number(bud))
    }
    else{
      const th = formData.get('totalHours') as string;
      const hr = formData.get('hourlyRate') as string
      const tb = Number(th) * Number(hr)
       setBudget(tb) 
    }
    setShowReviewPopup(true);
  }

 

const handleFinalSubmit = async () => {
  setIsUploadingImages(true);
  setIsSubmitting(true);

  const data = pendingFormData;
  if (!data) {
    setIsSubmitting(false);
    setIsUploadingImages(false);
    return;
  }

  const { hourlyRate, totalHours, budget, description, urgency } = data;
  const codeToSend = appliedVoucherCode || '';

  if (voucherCode.trim() && voucherCode.trim().toUpperCase() !== appliedVoucherCode) {
    setIsUploadingImages(false);
    setIsSubmitting(false);
    return toast.error(t('voucher_apply_required'));
  }

  if (!selectedLocation) {
    setIsUploadingImages(false);
    setIsSubmitting(false);
    return toast.error("Por favor selecciona una ubicación.");
  }

  if (selectedPayment === 'hourly' && (!hourlyRate || !totalHours || !description)) {
    setIsUploadingImages(false);
    setIsSubmitting(false);
    return toast.error("Por favor completa todos los campos obligatorios");
  }

  if (selectedPayment === 'fixed' && (!budget || !description)) {
    setIsUploadingImages(false);
    setIsSubmitting(false);
    return toast.error("Por favor completa todos los campos obligatorios");
  }

  try {
    let uploadedImageUrls: string[] = [];

    try {
      uploadedImageUrls = await uploadImages();
    } catch (uploadError: any) {
      console.error("Error uploading images:", uploadError);
      toast.error(
        uploadError?.message ||
          "No se pudieron subir las imágenes. Inténtalo de nuevo."
      );
      setIsSubmitting(false);
      setIsUploadingImages(false);
      return;
    }

    const jobData = {
      paymentType: selectedPayment,
      hourlyRate: selectedPayment === 'hourly' ? Number(hourlyRate) : undefined,
      totalHours: selectedPayment === 'hourly' ? Number(totalHours) : undefined,
      description,
      service: selectedService,
      category: selectedCategoryId,
      location: {
        type: "Point",
        coordinates: [selectedLocation.lng, selectedLocation.lat],
        value: selectedLocation.address,
      },
      schedule: {
        startDateTime: startDate,
        endDateTime: startDate,
      },
      budget:
        selectedPayment === 'hourly'
          ? Number(hourlyRate) * Number(totalHours)
          : Number(budget),
      workerId: workerid,
      imageUrls: uploadedImageUrls,
      urgency,
      ...(codeToSend ? { voucherCode: codeToSend } : {}),
      isProposalSent: true
    };

    // 🔥 DECISION POINT
    const res = jobId
      ? await api.updateJobProposalForWorker(existingJobId, jobData)
      : await api.createJobForWorker({
          ...jobData,
          user: clientDetails?._id,
        //  customerStripeId: clientDetails?.stripeId || 'dscse',
          isDirectHire: true,
          isProposalSent: true
        });

    if (res && res.success) {
      setShowReviewPopup(false);
      setPendingFormData(null);
      setVoucherCode('');
      clearAppliedVoucher();
      toast.success("Proposal Sent Successfully");

      trackUserAction('proposal_sent', {
        worker_id: workerid,
        client_id: clientDetails?._id,
        job_type: jobtype,
        budget: jobData.budget,
        payment_type: selectedPayment,
        user_type: 'worker',
        mode: jobId ? 'update' : 'create',
      });
      trackMetaSubmitApplication({
        content_name: 'proposal',
        content_ids: workerid,
        value: Number(jobData.budget) || 0,
        currency: 'USD',
      });

      if (onSuccess) onSuccess();
    } else {
      toast.error(
        getBackendCallErrorMessage(res) ||
          t('voucher_invalid') ||
          "Algo salió mal. Por favor, inténtalo de nuevo."
      );
    }

  } catch (error: any) {
    console.error(t('errorCreatingJob'), error);
    toast.error(
      getBackendCallErrorMessage(error) ||
        error?.message ||
        "Algo salió mal. Por favor, inténtalo de nuevo."
    );
  } finally {
    setIsSubmitting(false);
    setIsUploadingImages(false);
  }
};






  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const fetchedServiceCategories = await api.getServiceCategoriesForProposal(workerProfileId,workerid);


        // Fetch worker details after service categories are loaded
        const workerResponse = await api.getWorkerById(workerProfileId);
        setWorkerDetails(workerResponse);

        // Set the selected category based on worker's serviceCategory
        if (workerResponse?.serviceCategory && fetchedServiceCategories?.length > 0) {
          const workerServiceCategory = fetchedServiceCategories.find(cat => cat._id === workerResponse.serviceCategory);
          setServiceCategories([workerServiceCategory]);
          setSelectedCategoryId(workerResponse.serviceCategory);
        }
      } catch (err) {
        console.error("Failed to fetch options:", err);
      } finally{
         setIsLoading(false);
      }
    };

    fetchOptions();
    
  }, [workerProfileId, i18n.language]);

  useEffect(() => {
    const selectedCategory = serviceCategories.find(cat => cat._id === selectedCategoryId);
    if (selectedCategory && workerDetails?.servicesOffered) {
      const workerServiceIds = workerDetails.servicesOffered.map((service: any) =>
        typeof service === 'string' ? service : service._id
      );
      const services = selectedCategory.services.filter((service: any) => {
        return workerServiceIds.includes(service._id);
      });
      setCategoryServices(services || []);
    } else {
      setCategoryServices([]);
    }
  }, [selectedCategoryId, serviceCategories, workerDetails]);


  const resizeImage = async (file: File) => {
    if (file.size > 10 * 1024 * 1024) {
    toast.error("La foto de perfil no puede superar los 10MB");
    return;
  }

    return new Promise<Blob>((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        'JPEG',
        90,
        0,
        (uri: any) => {
          resolve(uri);
        },
        'blob'
      );
    });
  };



  const uploadImages = async (): Promise<string[]> => {
    if (selectedImages.length === 0) return [];

    const uploadedUrls: string[] = [];

    for (const image of selectedImages) {
      const resizedImage = await resizeImage(image);
      const formData = new FormData();
      formData.append('file', resizedImage);
     
      const response = await api.updateJobPhoto(formData);

      if (response && response.success) {
        uploadedUrls.push(response.data || response);
      } else {
        toast.error("No se pudieron subir las imágenes. Inténtalo de nuevo.");
        throw new Error(`No se pudo subir la imagen : ${response?.message || 'Error desconocido'}`);
      }
    }

    return uploadedUrls;
  };
const handleImageChange = (files: File[]) => {
  const totalImages = selectedImages.length + files.length;
  if (totalImages > 5) {
    toast.error('Solo puedes seleccionar hasta 5 imágenes.');
    return;
  }

  const newValidFiles: File[] = [];
  const newPreviewUrls: string[] = [];

  for (const file of files) {
    if (file.size > 10 * 1024 * 1024) {
      toast.error(`La imagen es mayor a 10MB y fue omitida.`);
      continue;
    }

    newValidFiles.push(file);
    newPreviewUrls.push(URL.createObjectURL(file));
  }

  setSelectedImages(prev => [...prev, ...newValidFiles]);
  setImagePreviews(prev => [...prev, ...newPreviewUrls]);
};


  const handleRemoveImage = (index: number) => {
    setSelectedImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  const handleGooglePlaceSelect = async (val: any) => {
    setGooglePlace(val);
    if (val?.value?.place_id) {
      const [geocode] = await geocodeByPlaceId(val.value.place_id);
      setSelectedLocation({
        lat: geocode.geometry.location.lat(),
        lng: geocode.geometry.location.lng(),
        address: geocode.formatted_address,
      });
      setGooglePlaceAddress(geocode.formatted_address);
    }
  };

  const handleLocationSave = (location: LocationData) => {
    setSelectedLocation(location);
    setGooglePlace(location.address
      ? { label: location.address, value: { description: location.address } }
      : null);
    setGooglePlaceAddress(location.address || '');
    setShowLocationPopup(false);
  };


  // Helper to extract lat/lng/address from googlePlace
  function getGooglePlaceLocation(googlePlace: any): LocationData | undefined {
    if (!googlePlace || !googlePlace.value) return undefined;
    if (googlePlace.value.lat && googlePlace.value.lng) {
      return {
        lat: googlePlace.value.lat,
        lng: googlePlace.value.lng,
        address: googlePlace.label || googlePlace.value.description || '',
      };
    }
    return undefined;
  }


  
  return (
    <ContentContainer className="!p-0 !px-3 relative overflow-visible">

      {isLoading && (
  <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/60 backdrop-blur-sm">
    <div className="flex flex-col items-center">
      <div className="w-12 h-12 border-4 border-t-transparent border-white rounded-full animate-spin mb-3"></div>
      <p className="text-white text-sm ">Loading Proposal PopUp...</p>
    </div>
  </div>
)}

      {/* Mobile-only date picker styles */}
      <style>{mobileDatePickerStyles}</style>
      
      <LocationPickerPopup
        isOpen={showLocationPopup}
        onClose={() => setShowLocationPopup(false)}
        onSubmit={handleLocationSave}
        initialLocation={
          getGooglePlaceLocation(googlePlace) || selectedLocation || undefined
        }
        googlePlacesApiKey={googlePlacesApiKey}
      />
   <Popup
  isOpen={showReviewPopup}
  handleClose={() => setShowReviewPopup(false)}
  className="bg-white"
  isShowCloseIcon={false}
  isShowDeleteIcon={false}
  size="sm"
  slotProps={{
    root: { sx: { zIndex: 4001 } },
  }}
  bodyChildren={
    <div className="flex flex-col" style={{ fontFamily: 'Object Sans, sans-serif', padding: '24px' }}>
      {/* Header */}
      <h2 className="font-bold text-center mb-6" style={{ fontSize: '20px', color: '#000000' }}>
        {t('confirmYourService')}
      </h2>

      {/* Description */}
      <p className="text-center mb-6" style={{ fontSize: '15px', color: '#333333', lineHeight: '1.5' }}>
        {t('providerConfirmDescription')}
      </p>

      {/* Breakdown Card */}
      {Budget > 0 && (() => {
        const feePct = Number(providerCommission || 8);
        const fullFee = Budget * (feePct / 100);
        const earningsBeforeVoucher = Budget - fullFee;
        const preview =
          voucherPreview &&
          appliedVoucherCode &&
          Math.abs(Number(voucherPreview.budget) - Budget) <= 0.009
            ? voucherPreview
            : null;

        return (
        <div className="w-full mb-6" style={{ backgroundColor: '#F5F5F3', border: '1px solid #E5E5E5', borderRadius: '8px', padding: '16px' }}>
          <div className="flex flex-col" style={{ fontSize: '15px', color: '#333333', gap: '8px' }}>
            <div className="flex justify-between">
              <span>{t('serviceAmount')}:</span>
              <span className="font-medium">${Budget.toFixed(2)}</span>
            </div>

            {preview ? (
              <>
                <div className="flex justify-between">
                  <span>
                    {t('platformFeeBeforeDiscount')} ({preview.workerShareBeforeDiscount.percentage}%):
                  </span>
                  <span className="font-medium">
                    ${Number(preview.workerShareBeforeDiscount.amount).toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>
                    {t('voucher_discount')} ({preview.workerDiscount.percentage}%):
                  </span>
                  <span className="font-medium text-green-700">
                    -${Number(preview.workerDiscount.amount).toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>
                    {t('platformFeeAfterDiscount')} ({preview.workerShareAfterDiscount.percentage}%):
                  </span>
                  <span className="font-medium">
                    ${Number(preview.workerShareAfterDiscount.amount).toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>{t('voucher_code')}:</span>
                  <span className="font-medium">{preview.voucherCode}</span>
                </div>
                <div className="flex justify-between pt-2 mt-2" style={{ borderTop: '1px solid #E5E5E5' }}>
                  <span className="font-bold" style={{ fontSize: '17px', color: '#000000' }}>
                    {t('yourGuaranteedEarnings')}:
                  </span>
                  <span className="font-bold" style={{ fontSize: '17px', color: '#4285F4' }}>
                    ${Number(preview.providerEarningsAfterDiscount).toFixed(2)}
                  </span>
                </div>
              </>
            ) : (
              <>
                <div className="flex justify-between">
                  <span>{t('businessGrowthUpgrade')} ({feePct}%):</span>
                  <span className="font-medium">${fullFee.toFixed(2)}</span>
                </div>
                <div className="flex justify-between pt-2 mt-2" style={{ borderTop: '1px solid #E5E5E5' }}>
                  <span className="font-bold" style={{ fontSize: '17px', color: '#000000' }}>{t('yourGuaranteedEarnings')}:</span>
                  <span className="font-bold" style={{ fontSize: '17px', color: '#000000' }}>${earningsBeforeVoucher.toFixed(2)}</span>
                </div>
              </>
            )}
          </div>
        </div>
        );
      })()}

      {/* Footer */}
      <p className="text-center mb-6" style={{ fontSize: '15px', color: '#333333', lineHeight: '1.5' }}>
        {t('providerConfirmFooter')}
      </p>

      {/* Action buttons */}
      <div className="flex gap-4 justify-center">
        <CustomButton
          label={t('back')}
          handleButtonClick={() => setShowReviewPopup(false)}
          className="!rounded-lg bg-white border border-[#CCCCCC]"
          style={{ padding: '12px 14px', borderRadius: '8px' }}
          labelStyle="text-[#444444]"
        />

        <CustomButton
          label={t('submitProposal')}
          handleButtonClick={handleFinalSubmit}
          className="!rounded-lg font-semibold bg-[#4285F4]"
          style={{ padding: '12px 14px', borderRadius: '8px' }}
          disabled={isSubmitting}
          labelStyle="text-white"
        />
      </div>
    </div>
  }
/>

      <div className="login-form default-form  ">


        <h3 className="text-center" style={{ color: "white", fontWeight: 600 }}>{t('sendProposal')}</h3>

        {/* <!--Login Form--> */}
        <form method="post" onSubmit={handleSendProposal}>



            <div className="form-group">
              <label style={{ color: "white" }}>{t('serviceCategory')} <span style={{ color: "red" }}> *</span></label>
              <select
                className="form-select"
                required
                value={selectedCategoryId}
                onChange={(e) => {
                  setSelectedCategoryId(e.target.value);
                  setSelectedService(""); // reset service
                }}
              >
                <option value="" disabled hidden>{t('selectCategory')}</option>
                {serviceCategories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>


   <div className="form-group">
              <label style={{ color: "white" }}>{t('service')} <span style={{ color: "red" }}> *</span></label>
              <select
                name="services"
                className="form-select"
                required
                value={selectedService}
                onChange={(e) => setSelectedService(e.target.value)}
                disabled={!selectedCategoryId} // ✅ disables the dropdown if no category is selected
              >
                <option value="" disabled hidden>{t('selectServiceOffered')}</option>

                {categoryServices.map((service) => (
                  <option key={service._id} value={service._id}>
                    {service.name}
                  </option>
                ))}

              </select>
            </div>



            <div className="form-group">
              <TextArea
                label={t('descriptionofRequestedService')}
                labelClassName='!text-white text-base'
                type="text"
                name="description"
                placeholder={t('descriptionofRequestedService')}
                className='placeholder:text-placeholder'
                required
              />
            </div>


   {/* Location Field */}
            <div className="form-group">
              <label style={{ color: "white" }}>
                {t('serviceLocation')}<span style={{ color: "red" }}> *</span>
              </label>
              <div className="relative mt-2 w-full flex items-center gap-2">
                <div className="flex-1">
                  <GooglePlacesAutocomplete
                    apiKey={googlePlacesApiKey}
                    selectProps={{
                      value: googlePlace,
                      onChange: handleGooglePlaceSelect,
                      placeholder: t('search_location'),
                      isClearable: true,
                    }}
                    autocompletionRequest={{
                      componentRestrictions: { country: 'PR' }
                    }}
                  />
                </div>
                <span
                  className="ml-2 text-gray-400 cursor-pointer flex items-center justify-center bg-white rounded-full p-2"
                  onClick={() => setShowLocationPopup(true)}
                  title={t('chooseLocationOnMap')}
                >
                  <LocationPinIcon className="w-6 h-6" />
                </span>
              </div>
            </div>


    <div className="form-group">
  {/* Start Date & Time */}
  <div className="w-full">
    <label style={{ color: "white" }} className="mb-1 block">
      {t("select_start_date_time")} <span style={{ color: "red" }}> *</span>
    </label>
    {/* ✅ AM/PM format applied below */}
  <DatePicker
  selected={startDate}
  onChange={(date: Date | null) => {
    setStartDate(date);
    setEndDate(null);
  }}
  showTimeSelect
  timeFormat="hh:mm aa"
  timeIntervals={15}
  dateFormat="MMMM d, yyyy h:mm aa"
  placeholderText={t("select_start_date_time")}
  className="!w-full p-3 rounded-md border placeholder:text-placeholder border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-black"
  wrapperClassName="w-full"
  minDate={new Date()}
  minTime={getMinTime(startDate)}
  maxTime={getMaxTime(startDate)}
/>
  </div>
</div>




   {/* Urgency Select */}
            <div className="form-group">
              <label className="!text-white !font-semibold">{t('urgency')} <span style={{ color: "red" }}> *</span></label>
              <select
                className="form-select"
                value={urgency}
                onChange={e => setUrgency(e.target.value as 'low' | 'medium' | 'high')}
                required
              >
                <option value="low">{t('low')}</option>
                <option value="medium">{t('medium')}</option>
                <option value="high">{t('high')}</option>
              </select>
            </div>

          <div className='flex flex-col gap-2'>

            {/* <Inputfield
              label={t('title')}
              labelClassName='!text-white !font-semibold'
              type="text"
              name="title"
              placeholder={t('enter_proposal_title')}
              required
            /> */}

            <div className="form-group">
              <label style={{ color: "white" }}>{t('select_payment_type')} <span style={{ color: "red" }}> *</span></label>
              <select
                className="form-select"
                required
                value={selectedPayment}
                onChange={(e) => {
                  setSelectedPayment(e.target.value);
                }}
              >
                <option value="" disabled hidden>{t('select_payment_type')}</option>
                {paymentOptions.map((payment, index) => (
                  <option key={index + Math.random()} value={payment.value}>
                    {t(payment.label)}
                  </option>
                ))}
              </select>
            </div>

            {/* Conditional fields based on payment type */}
            {selectedPayment === 'hourly' && (
              <>
                <Inputfield
                  label={t('hourlyRate')}
                  labelClassName='!text-white !font-semibold'
                  type="number"
                  name="hourlyRate"
                  placeholder={t('hourlyRate')}
                  min={1}
                  max={1000}
                  required
                  onWheel={(e) => e.currentTarget.blur()}
                />

                <Inputfield
                  label={t('totalHours')}
                  labelClassName='!text-white !font-semibold'
                  type="number"
                  name="totalHours"
                  placeholder={t('totalHours')}
                  required
                  min={1}
                  max={24}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </>
            )}

            {selectedPayment === 'fixed' && (
              <Inputfield
                label={t('budget')}
                labelClassName='!text-white !font-semibold'
                type="number"
                name="budget"
                placeholder={t('enter_total_budget')}
                defaultValue={Budget || ''}
                required
                min={1}
                max={100000}
                onWheel={(e) => e.currentTarget.blur()}
              />
            )}

            {/* Provider promo / voucher — Apply validates immediately via preview API */}
            <div
              className="form-group rounded-lg p-4"
              style={{ backgroundColor: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)' }}
            >
              <label className="!text-white !font-semibold block mb-1">
                {t('provider_voucher_section_title')}
              </label>
              <p className="text-xs mb-3" style={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.4 }}>
                {t('provider_voucher_help_apply')}
              </p>
              <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                <input
                  type="text"
                  name="voucherCode"
                  value={voucherCode}
                  onChange={(e) => {
                    const next = e.target.value.toUpperCase();
                    setVoucherCode(next);
                    if (appliedVoucherCode && next.trim() !== appliedVoucherCode) {
                      clearAppliedVoucher();
                    }
                  }}
                  placeholder={t('provider_voucher_placeholder')}
                  className="form-control rounded-[7px] flex-1 text-black"
                  autoComplete="off"
                  spellCheck={false}
                />
                <div className="flex items-center gap-3">
                  <CustomButton
                    type="button"
                    label={t('apply_voucher')}
                    className="!rounded-3xl !bg-black px-5 py-2"
                    labelStyle="text-sm text-white"
                    isLoading={isApplyingVoucher}
                    disabled={!voucherCode.trim() || isApplyingVoucher}
                    handleButtonClick={handleApplyProviderVoucher}
                  />
                  {(appliedVoucherCode || voucherCode.trim()) && (
                    <button
                      type="button"
                      className="text-sm text-white underline whitespace-nowrap"
                      onClick={handleClearProviderVoucher}
                      disabled={isApplyingVoucher}
                    >
                      {t('clear_voucher_code')}
                    </button>
                  )}
                </div>
              </div>

              <AssignedVoucherPicker
                vouchers={usableAssignedVouchers}
                selectedCode={appliedVoucherCode || voucherCode}
                disabled={isApplyingVoucher}
                variant="dark"
                onSelect={(code) => {
                  setVoucherCode(code);
                  handleApplyProviderVoucher(code);
                }}
              />

              {voucherPreview && appliedVoucherCode && (
                <div
                  className="mt-3 rounded-md p-3 text-sm"
                  style={{ backgroundColor: 'rgba(0,0,0,0.25)', color: '#fff' }}
                >
                  <div className="flex justify-between gap-2">
                    <span>{t('platformFeeBeforeDiscount')}</span>
                    <span>
                      ${Number(voucherPreview.workerShareBeforeDiscount.amount).toFixed(2)}
                      {' '}({voucherPreview.workerShareBeforeDiscount.percentage}%)
                    </span>
                  </div>
                  <div className="flex justify-between gap-2 text-green-300">
                    <span>{t('voucher_discount')}</span>
                    <span>
                      -${Number(voucherPreview.workerDiscount.amount).toFixed(2)}
                      {' '}({voucherPreview.workerDiscount.percentage}%)
                    </span>
                  </div>
                  <div className="flex justify-between gap-2">
                    <span>{t('platformFeeAfterDiscount')}</span>
                    <span>
                      ${Number(voucherPreview.workerShareAfterDiscount.amount).toFixed(2)}
                      {' '}({voucherPreview.workerShareAfterDiscount.percentage}%)
                    </span>
                  </div>
                  <div className="flex justify-between gap-2 font-semibold mt-1 pt-1 border-t border-white/20">
                    <span>{t('yourGuaranteedEarnings')}</span>
                    <span>${Number(voucherPreview.providerEarningsAfterDiscount).toFixed(2)}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="flex flex-col gap-6 h-full">
              <div className='flex items-start justify-start w-full gap-6 '>
                <DragDropImagePicker isRequired={false} onImageSelected={handleImageChange} acceptedFile={FileTypes.image} multiple maxFiles={5 - selectedImages.length} />
              </div>
              {imagePreviews.length > 0 && (
                <div className="flex flex-wrap gap-4 mt-4">
                  {imagePreviews.map((preview, idx) => (
                    <div key={idx} className="relative">
                      <img src={preview} alt={`Selected ${idx + 1}`} className="h-20 w-32 rounded-md border border-gray-lighter object-cover" />
                      <button
                        type="button"
                        className="absolute -top-2 -right-2 flex items-center justify-center w-4 h-4 bg-white shadow rounded-full border border-gray-300 cursor-pointer"
                        onClick={() => handleRemoveImage(idx)}
                        aria-label={t('removeImage')}
                      >
                        <span className="text-black text-lg font-bold">×</span>
                      </button>
                    </div>
                  ))}
                </div>
              )}

            </div>

            <CustomButton
              type="submit"
              label={isSubmitting ? t('creatingJob') : t('sendProposalToClient')}
              className={`!rounded-3xl w-full !bg-black h-14 mt-6 ${isSubmitting ? 'opacity-75' : ''}`}
              labelStyle="text-md text-white"
              disabled={isSubmitting}
              icon={
                isSubmitting && (
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                )
              }
            />

          </div>
        </form>


        {/* End bottom-box LoginWithSocial */}
      </div>
    </ContentContainer>
  )
}

export default SendProposal